module.exports = __webpack_public_path__ + "img/gend2_zh.1e50156.png";